// ON CLICK SECOND STEP OPEN POPUP SCRIPT START
document.addEventListener("DOMContentLoaded", function () {
  const popupBtns = document.querySelectorAll(
    ".choose-setting, .stone-select-btn"
  );
  const popup = document.querySelector(".same-pop-style");
  const overlay = document.querySelector(".light-d-overlay");
  const closeBtn = document.querySelector(".same-popup-close-btn");

  function openPopup() {
    popup.classList.remove("closing");
    popup.classList.add("open");
    if (overlay) overlay.classList.add("open");
    document.body.classList.add("js-popup-open");
  }

  function closePopup() {
    popup.classList.add("closing");
    popup.classList.remove("open");
    if (overlay) overlay.classList.remove("open");
    document.body.classList.remove("js-popup-open");

    setTimeout(() => popup.classList.remove("closing"), 400);
  }

  popupBtns.forEach((btn) => btn.addEventListener("click", openPopup));
  if (closeBtn) closeBtn.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);
});
